import { useApolloClient } from '@apollo/react-hooks';
import gql from 'not-graphql-tag';
import { CustomerContactInput } from '../__generated__/pge-types';

const CREATE_CUSTOMER_CONTACT = gql`
  mutation CreateWebCustomerContact($params: CustomerContactInput!) {
    createWebCustomerContact(params: $params)
  }
`;

export function useCreateCustomerContact() {
  const apolloClient = useApolloClient();
  async function submit(payload: CustomerContactInput) {
    const result = await apolloClient.mutate<{
      createWebCustomerContact: boolean;
    }>({
      mutation: CREATE_CUSTOMER_CONTACT,
      variables: {
        params: payload,
      },
    });
    return result;
  }

  return { submit };
}
